import { gql } from '@apollo/client';

const changeDateRequestReviewPageNotificationFragment = gql`
  fragment ChangeDateRequestReviewPageNotificationFields on EventChangeDateRequestReviewPageNotification {
    RequestId
  }
`;

export default changeDateRequestReviewPageNotificationFragment;
